import React, { useState } from "react";
import MainScreen from "../MainScreen/MainScreen";
import {
  Gate2020,
  Gate2021,
  c6,
  c7,
  c9,
  c10,
  c11,
  c12,
  c16,
} from "../../assets";

const Achievement = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const subHeading = [
    "Key Milestones",
    "Notable Successes",
    "Track Record",
    "Impact Points",
    "Unlocked Goals",
  ];

  const exams = [
    {
      image: Gate2020,
      title: "GATE 2020 Exam Qualified",
      organization: "Conducting Organisation: IIT Delhi",
      score: "GATE Score: 363",
    },
    {
      image: Gate2021,
      title: "GATE 2021 Exam Qualified",
      organization: "Conducting Organisation: IIT Bombay",
      score: "GATE Score: 415",
    },
  ];

  const certificates = [
    { image: c6, title: "Certificate 6" },
    { image: c7, title: "Certificate 7" },
    { image: c9, title: "Certificate 9" },
    { image: c10, title: "Certificate 10" },
    { image: c11, title: "Certificate 11" },
    { image: c12, title: "Certificate 12" },
    { image: c16, title: "Certificate 16" },
  ];

  const openOverlay = (image) => {
    setSelectedImage(image);
    setIsOverlayOpen(true);
  };

  const closeOverlay = () => {
    setIsOverlayOpen(false);
    setSelectedImage(null);
  };

  return (
    <MainScreen heading={"My Achievements"} subHeading={subHeading}>
      <div className="achievementWrapper">
        <div className="examSection">
          {exams.map((exam, index) => (
            <div key={index} className="examCard">
              <div className="examImageWrapper">
                <img src={exam.image} alt={exam.title} />
              </div>
              <div className="examInfo">
                <h3>{exam.title}</h3>
                <p>{exam.organization}</p>
                <p>{exam.score}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="certificateSection">
          <h2>Certifications</h2>
          <div className="certificateGrid">
            {certificates.map((cert, index) => (
              <div key={index} className="certificateCard">
                <img
                  src={cert.image}
                  alt={cert.title}
                  onClick={() => openOverlay(cert.image)}
                  style={{ cursor: "pointer" }}
                />
                <p>{cert.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {isOverlayOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={closeOverlay}
        >
          <img
            src={selectedImage}
            alt="Certificate"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </MainScreen>
  );
};

export default Achievement;
